import styled from 'styled-components';

import Holidays from 'components/Recurring/Holidays/container';

export default styled(Holidays)`
  &.holidays {
    border-radius: 4px;
    border: solid 1px #fcc475;
    background-color: #fff2e0;
    padding: 12px 18px;
  }
`;
